<template>
  <div id="app">
    <quietmed2Header></quietmed2Header>
      <router-view></router-view>
    <quietmed2Footer></quietmed2Footer>
  </div>
</template>
<script>
import quietmed2Footer from '@/components/footer'
import quietmed2Header from '@/components/header'
export default {
  name: 'App',
  components: {
    quietmed2Footer,
    quietmed2Header,
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
